import {invalidateBillingAlerts} from 'modules/store/billingAlerts';
import {invalidateBillingAlertsStates} from 'modules/store/billingAlertsStates';
import {invalidateBillingAlertsTypes} from 'modules/store/billingAlertsTypes';

const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
const CLEAR_SELECTED_ITEMS = 'CLEAR_SELECTED_ITEMS';
const REMOVE_SELECTED_ITEMS = 'REMOVE_SELECTED_ITEMS';
const CLEAR_ALERTS_TO_DELETE = 'CLEAR_ALERTS_TO_DELETE';
const TOGGLE_ALERT_TO_DELETE = 'TOGGLE_ALERT_TO_DELETE';

export const parseStates = (states, formatMessage) => states.map(value => ({...value, name: formatMessage({id: `billingAlerts.state.${value.id.toLowerCase()}`})}));
export const parseEntityTypes = (types, formatMessage) => types.map(value => ({...value, name: formatMessage({id: `billingAlerts.entityType.${value.name.toLowerCase()}`})}));

export const invalidateBillingAlertsTable = () => dispatch => {
    dispatch(invalidateBillingAlerts());
    dispatch(invalidateBillingAlertsStates());
    dispatch(invalidateBillingAlertsTypes());
    dispatch(clearSelectedAlerts());
};


// Reducer
const _defaultState = () => ({
    selectedItems:  [],
    selectedAlerts: []
});

/*eslint-disable */
const _removeSelectedItems = (clicked, selectedItems) => selectedItems.filter(item => {
    if (item.id !== clicked) {
        return item;
    }
});
/*eslint-enable */

const _toggleAlertToDelete = (alertsToToggle, alertsStorage, state) => {
    const ZERO = 0;
    let alerts;

    if (state) {
        alerts = alertsToToggle.filter(item => {
            if (state.includes(item.state)) {
                return item;
            }

            return null;
        });
    } else {
        alerts = alertsToToggle.slice(ZERO);
    }

    alertsStorage.forEach(alert => {
        const back = alerts.slice(ZERO);

        alerts = alerts.filter(item => {
            if (item.id !== alert.id) {
                return item;
            }

            return null;
        });

        if (back.length === alerts.length) {
            alerts.push(alert);
        }
    });

    return alerts;
};

export const setSelectedItems = selectedItems => ({
    type: SET_SELECTED_ITEMS,
    selectedItems
});

export const clearSelectedItems = () => ({
    type: CLEAR_SELECTED_ITEMS
});

export const removeSelectedItems = (item, selectedItems) => ({
    type: REMOVE_SELECTED_ITEMS,
    item,
    selectedItems
});

export const toggleAlertToDelete = (alerts, stateToFilter) => ({
    type:          TOGGLE_ALERT_TO_DELETE,
    alerts:        Array.isArray(alerts) ? alerts : [alerts],
    stateToFilter: Array.isArray(stateToFilter) ? stateToFilter : stateToFilter ? [stateToFilter] : undefined
});

export const clearSelectedAlerts = () => ({
    type: CLEAR_ALERTS_TO_DELETE
});

export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case SET_SELECTED_ITEMS:
        return {
            ...state,
            selectedItems: action.selectedItems
        };
    case CLEAR_SELECTED_ITEMS:
        return {
            ...state,
            selectedItems: []
        };
    case REMOVE_SELECTED_ITEMS:
        return {
            ...state,
            selectedItems: _removeSelectedItems(action.item, action.selectedItems)
        };
    case TOGGLE_ALERT_TO_DELETE:
        return {
            ...state,
            selectedAlerts: _toggleAlertToDelete(action.alerts, state.selectedAlerts, action.stateToFilter)
        };
    case CLEAR_ALERTS_TO_DELETE:
        return {
            ...state,
            selectedAlerts: []
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/alertsForm.js